(function migratorModuleDefinition() {
    'use strict';

    angular.module('Migrator', ['ui.router', 'ui.bootstrap.carousel', 'Config', 'Entities', 'ClickOnce', 'TranslatedPaginator'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
        function migratorConfig(config, $stateProvider, loginProvider) {
            $stateProvider.state('migrator-find', {
                url: '/Migrator/List',
                templateUrl: config.resourceUrl('/views/Migrator/list.html'),
                controller: 'MigratorFindController',
                authorize: true,
                roles: loginProvider.roleCondition('MIGRATOR READ').or('MIGRATOR WRITE')
            });

            $stateProvider.state('migrator-detail', {
                url: '/Migrator/Detail/{id}',
                templateUrl: config.resourceUrl('/views/migrator/detail.html'),
                controller: 'MigratorDetailController',
                authorize: true,
                roles: loginProvider.roleCondition('MIGRATOR READ').or('MIGRATOR WRITE')
            });

            $stateProvider.state('migrator-batch-detail', {
                url: '/Migrator/{id}/Batch/Detail/{nro}',
                templateUrl: config.resourceUrl('/views/migrator/batch-detail.html'),
                controller: 'MigratorBatchDetailController',
                authorize: true,
                roles: loginProvider.roleCondition('MIGRATOR READ').or('MIGRATOR WRITE')
            });
        }
        ]);
})();